export default __webpack_public_path__ + "static/media/cert1.26015060.jpg";